import React from 'react';

// SVG Icon Components
export const CameraIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" stroke={color} strokeWidth="2" fill="none"/>
    <circle cx="12" cy="13" r="4" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const LockIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke={color} strokeWidth="2" fill="none"/>
    <circle cx="12" cy="7" r="4" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const EditIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const PauseIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <rect x="6" y="4" width="4" height="16" fill={color}/>
    <rect x="14" y="4" width="4" height="16" fill={color}/>
  </svg>
);

export const PlayIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <polygon points="5,3 19,12 5,21" fill={color}/>
  </svg>
);

export const DeleteIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <polyline points="3,6 5,6 21,6" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke={color} strokeWidth="2" fill="none"/>
    <line x1="10" y1="11" x2="10" y2="17" stroke={color} strokeWidth="2"/>
    <line x1="14" y1="11" x2="14" y2="17" stroke={color} strokeWidth="2"/>
  </svg>
);

export const StoreIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke={color} strokeWidth="2" fill="none"/>
    <polyline points="9,22 9,12 15,12 15,22" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const ShoppingCartIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="9" cy="21" r="1" fill={color}/>
    <circle cx="20" cy="21" r="1" fill={color}/>
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const StarIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" fill={color}/>
  </svg>
);

export const UserIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke={color} strokeWidth="2" fill="none"/>
    <circle cx="12" cy="7" r="4" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const ViewIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke={color} strokeWidth="2" fill="none"/>
    <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const DateIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke={color} strokeWidth="2" fill="none"/>
    <line x1="16" y1="2" x2="16" y2="6" stroke={color} strokeWidth="2"/>
    <line x1="8" y1="2" x2="8" y2="6" stroke={color} strokeWidth="2"/>
    <line x1="3" y1="10" x2="21" y2="10" stroke={color} strokeWidth="2"/>
  </svg>
);

export const MoneyIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <line x1="12" y1="1" x2="12" y2="23" stroke={color} strokeWidth="2"/>
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const TagIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" stroke={color} strokeWidth="2" fill="none"/>
    <line x1="7" y1="7" x2="7.01" y2="7" stroke={color} strokeWidth="2"/>
  </svg>
);

export const TrophyIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M6 9H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h2" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M18 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-2" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M4 22h16" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M10 14.66V17c0 .55-.47.98-.97 1.21l-1.4.6c-.5.21-1.06.21-1.56 0l-1.4-.6C4.47 17.98 4 17.55 4 17v-2.34" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M20 14.66V17c0 .55.47.98.97 1.21l1.4.6c.5.21 1.06.21 1.56 0l1.4-.6C25.53 17.98 26 17.55 26 17v-2.34" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M12 14l-2-2 2-2 2 2-2 2z" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const ShieldIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const SearchIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="11" cy="11" r="8" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M21 21l-4.35-4.35" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const LightningIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <polygon points="13,2 3,14 12,14 11,22 21,10 12,10" fill={color}/>
  </svg>
);

export const FireIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" fill={color}/>
  </svg>
);

export const DiamondIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M6 3h12l4 6-10 12L2 9l4-6z" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const CrownIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M5 16L3 5l5.5 5L12 4l3.5 6L21 5l-2 11H5z" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M12 18l-1-6 1-6 1 6-1 6z" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const SparkleIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill={color}/>
  </svg>
);

export const GiftIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M20 12v10H4V12" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M2 7h20v5H2z" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M12 22V7" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const TargetIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" fill="none"/>
    <circle cx="12" cy="12" r="6" stroke={color} strokeWidth="2" fill="none"/>
    <circle cx="12" cy="12" r="2" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const ChartIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <line x1="18" y1="20" x2="18" y2="10" stroke={color} strokeWidth="2"/>
    <line x1="12" y1="20" x2="12" y2="4" stroke={color} strokeWidth="2"/>
    <line x1="6" y1="20" x2="6" y2="14" stroke={color} strokeWidth="2"/>
  </svg>
);

export const TrendingUpIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <polyline points="23,6 13.5,15.5 8.5,10.5 1,18" stroke={color} strokeWidth="2" fill="none"/>
    <polyline points="17,6 23,6 23,12" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const TrendingDownIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <polyline points="23,18 13.5,8.5 8.5,13.5 1,6" stroke={color} strokeWidth="2" fill="none"/>
    <polyline points="17,18 23,18 23,12" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const GamepadIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <line x1="6" y1="11" x2="10" y2="11" stroke={color} strokeWidth="2"/>
    <line x1="8" y1="9" x2="8" y2="13" stroke={color} strokeWidth="2"/>
    <line x1="15" y1="12" x2="15.01" y2="12" stroke={color} strokeWidth="2"/>
    <line x1="18" y1="10" x2="18.01" y2="10" stroke={color} strokeWidth="2"/>
    <path d="M17.32 5H6.68a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h10.64a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4z" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const MedalIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="8" r="6" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M12 14v6" stroke={color} strokeWidth="2" fill="none"/>
    <path d="M8 21l4-3 4 3" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const DiceIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke={color} strokeWidth="2" fill="none"/>
    <circle cx="8.5" cy="8.5" r="1.5" fill={color}/>
    <circle cx="15.5" cy="8.5" r="1.5" fill={color}/>
    <circle cx="8.5" cy="15.5" r="1.5" fill={color}/>
    <circle cx="15.5" cy="15.5" r="1.5" fill={color}/>
    <circle cx="12" cy="12" r="1.5" fill={color}/>
  </svg>
);

export const UploadIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke={color} strokeWidth="2" fill="none"/>
    <polyline points="7,10 12,5 17,10" stroke={color} strokeWidth="2" fill="none"/>
    <line x1="12" y1="5" x2="12" y2="15" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const CheckIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <polyline points="20,6 9,17 4,12" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

export const XIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <line x1="18" y1="6" x2="6" y2="18" stroke={color} strokeWidth="2"/>
    <line x1="6" y1="6" x2="18" y2="18" stroke={color} strokeWidth="2"/>
  </svg>
);

export const PlusIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <line x1="12" y1="5" x2="12" y2="19" stroke={color} strokeWidth="2"/>
    <line x1="5" y1="12" x2="19" y2="12" stroke={color} strokeWidth="2"/>
  </svg>
);

export const PackageIcon = ({ size = 24, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M12.89 1.45l8 4A2 2 0 0 1 22 7.24v9.53a2 2 0 0 1-1.11 1.79l-8 4a2 2 0 0 1-1.78 0l-8-4a2 2 0 0 1-1.11-1.79V7.24a2 2 0 0 1 1.11-1.79l8-4a2 2 0 0 1 1.78 0z" stroke={color} strokeWidth="2" fill="none"/>
    <polyline points="2.32,6.16 12,11 21.68,6.16" stroke={color} strokeWidth="2" fill="none"/>
    <line x1="12" y1="22" x2="12" y2="11" stroke={color} strokeWidth="2"/>
  </svg>
);